module.exports = __webpack_public_path__ + "69cdddcf5fe04862142e5e06c6c61355.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/JuneCoco.jpg
// module id = 707
// module chunks = 0